(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1539],{

/***/ 21609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1954);
// ** Icon Imports


const IconifyIcon = (param)=>{
    let { icon , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
        icon: icon,
        fontSize: "1.5rem",
        ...rest
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconifyIcon);


/***/ }),

/***/ 61539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_WifiNetworks; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useExtremeUpgradeRefresh.js
var useExtremeUpgradeRefresh = __webpack_require__(57921);
// EXTERNAL MODULE: ./src/utils/i18n.js + 1 modules
var i18n = __webpack_require__(61906);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 13 modules
var TextField = __webpack_require__(2202);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(87109);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./src/@api/dashboard.js
var dashboard = __webpack_require__(95629);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 2 modules
var Drawer = __webpack_require__(77533);
// EXTERNAL MODULE: ./src/@core/components/icon/index.js
var icon = __webpack_require__(21609);
// EXTERNAL MODULE: ./src/@core/components/wifi-info/wifi-info.module.scss
var wifi_info_module = __webpack_require__(67135);
var wifi_info_module_default = /*#__PURE__*/__webpack_require__.n(wifi_info_module);
;// CONCATENATED MODULE: ./src/@core/components/wifi-info/index.js














function WifiDrawer(param, ref) {
    let { data  } = param;
    const [state, setState] = react.useState({
        right: false
    });
    const { t  } = (0,i18n/* useTranslation */.$G)("common");
    const toggleDrawer = (anchor, open)=>(event)=>{
            if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
                return;
            }
            setState({
                ...state,
                [anchor]: open
            });
        };
    function toggleDrawerParent(anchor, open) {
        setState({
            ...state,
            [anchor]: open
        });
    }
    (0,react.useImperativeHandle)(ref, ()=>({
            // 暴露给父组件的方法
            toggleDrawerParent
        }));
    const list = (anchor)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
                width: anchor === "top" || anchor === "bottom" ? "auto" : 300
            },
            role: "presentation",
            onClick: toggleDrawer(anchor, false),
            onKeyDown: toggleDrawer(anchor, false),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (wifi_info_module_default()).contactsInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (wifi_info_module_default()).arrow,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                            icon: "mdi:chevron-right"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (wifi_info_module_default()).top,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (wifi_info_module_default()).pic,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                    icon: "ic:outline-wifi",
                                    fontSize: "1.25rem",
                                    color: "#888888"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (wifi_info_module_default()).name,
                                children: data.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (wifi_info_module_default()).contentBox,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (wifi_info_module_default()).containers,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (wifi_info_module_default()).icon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                            icon: "ic:baseline-connect-without-contact"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (wifi_info_module_default()).text,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (wifi_info_module_default()).name,
                                                children: t("CONNECTED AT")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (wifi_info_module_default()).number,
                                                children: data.connectedAt
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (wifi_info_module_default()).containers,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (wifi_info_module_default()).icon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                            icon: "ic:twotone-more-time"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (wifi_info_module_default()).text,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (wifi_info_module_default()).name,
                                                children: t("USAGE TIME")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (wifi_info_module_default()).number,
                                                children: data.usageTime
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (wifi_info_module_default()).containers,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (wifi_info_module_default()).icon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                            icon: "mdi:latitude"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (wifi_info_module_default()).text,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (wifi_info_module_default()).name,
                                                children: t("Latitude")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (wifi_info_module_default()).number,
                                                children: data.latitude
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (wifi_info_module_default()).containers,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (wifi_info_module_default()).icon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                            icon: "tabler:world-longitude"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (wifi_info_module_default()).text,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (wifi_info_module_default()).name,
                                                children: t("Longitude")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (wifi_info_module_default()).number,
                                                children: data.longitude
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
            anchor: "right",
            open: state["right"],
            onClose: toggleDrawer("right", false),
            children: list("right")
        })
    });
}
WifiDrawer = /*#__PURE__*/ (0,react.forwardRef)(WifiDrawer);
/* harmony default export */ var wifi_info = (WifiDrawer);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/store/apps/Common/index.js
var Common = __webpack_require__(34745);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./src/utils/index.js
var utils = __webpack_require__(33185);
// EXTERNAL MODULE: ./src/@core/components/modal/extreme-upgrade/index.js + 4 modules
var extreme_upgrade = __webpack_require__(3769);
// EXTERNAL MODULE: ./src/hooks/useExtremeFeatureAccessGate.js
var useExtremeFeatureAccessGate = __webpack_require__(9644);
// EXTERNAL MODULE: ./src/@api/login.js + 1 modules
var login = __webpack_require__(53399);
;// CONCATENATED MODULE: ./src/components/WifiNetworks/index.js







// request











const ScrollDiv = (0,styled/* default */.ZP)("div")({
    "@media (max-width: 600px)": {
        "-msOverflowStyle": "none",
        /* 适用于 IE 和 Edge */ scrollbarWidth: "none",
        /* 适用于 Firefox */ "&::-webkit-scrollbar": {
            display: "none"
        }
    }
});
const WifiNetworks = (param)=>{
    let { type  } = param;
    let { data: userData  } = JSON.parse(localStorage.getItem("userData"));
    let getDeviceUser = JSON.parse(localStorage.getItem("DeviceUser")) != null ? JSON.parse(localStorage.getItem("DeviceUser")).username : "";
    const { t , locale  } = (0,i18n/* useTranslation */.$G)("common");
    let Advanced = window.localStorage.getItem("Advanced");
    Advanced = Advanced == null || Advanced == 0 ? true : false;
    const [initWifiNetwork, setInitWifiNetwork] = (0,react.useState)([]);
    const [wifiNetwork, setWifiNetwork] = (0,react.useState)([]);
    const [wifiInfo, setWifiInfo] = (0,react.useState)({});
    const childRef = (0,react.useRef)();
    const [isLoading, setIsLoading] = (0,react.useState)(true) //正在加载获取数据
    ;
    // 分页参数
    const [pagination, setPagination] = (0,react.useState)({
        reqNum: 50,
        nowOffset: 0,
        maxNum: false // 全部数据查询完毕
    });
    const [advanced, setAdvanced] = (0,react.useState)(true) // 是否购买高级服务
    ;
    const store = (0,es/* useSelector */.v9)((state)=>state.Common);
    const [fetchLoading, setFetchLoading] = (0,react.useState)(true) // 数据获取中
    ;
    const basicNotOver = [
        null,
        ""
    ].includes(store.resetTime.basicUpdateDownloadTime) // 是否未完成一步验证
    ;
    const advancedNotOver = [
        null,
        ""
    ].includes(store.resetTime.advancedUpdateDownloadTime) // 高级数据未下载完成（空 = 未完成）
    ;
    // 高级功能门控（对齐 SpyX）：未绑高级 → 跳 /ios/extreme-verification；数据未就绪 → 暂停渲染
    const { gatePending , showUpgradeModal  } = (0,useExtremeFeatureAccessGate/* useExtremeFeatureAccessGate */.t)(advanced);
    const [justVerified, setJustVerified] = (0,react.useState)(false) // 是否为刚完成验证
    ;
    const getWifiData = async (nowOffset)=>{
        let result = [];
        if (type === "android-local") {
            let response = await (0,dashboard/* getLocalAndroidAll */.gH)({
                username: userData.email,
                params: {
                    category: "WIFI",
                    deviceUdid: getDeviceUser,
                    offset: nowOffset,
                    limit: pagination.reqNum
                }
            });
            setIsLoading(false);
            if (!response.data.contents) return;
            result = response.data.contents;
        } else if (type === "google-cloud") {
            let response1 = await (0,dashboard/* getGcloudAll */.U1)({
                username: getDeviceUser,
                params: {
                    category: "WIFI"
                }
            });
            setIsLoading(false);
            if (!response1.data.contents) return;
            result = response1.data.contents;
        } else {
            const username = JSON.parse(localStorage.getItem("DeviceUser")) != null ? JSON.parse(localStorage.getItem("DeviceUser")).username : "";
            // 获取最近的10笔订单
            let res = await (0,login.getUserAccountOrder)({
                page: 1,
                pageSize: 10
            });
            // 查找有限期最长的订单
            const lastOrder = res.data.sort((a, b)=>dayjs_min_default()(b.expire_time).valueOf() - dayjs_min_default()(a.expire_time).valueOf())[0];
            // 计算是否为增值服务上线前付费用户
            // 增值服务上线前付费用户状态更新
            let response2 = await (0,dashboard/* getWifi */.bU)({
                username,
                params: {
                    category: "WIFI",
                    offset: nowOffset,
                    limit: pagination.reqNum,
                    deviceUdid: JSON.parse(localStorage.getItem("currentDevice")) != null ? JSON.parse(localStorage.getItem("currentDevice"))["Unique Identifier"] : ""
                }
            });
            setIsLoading(false);
            const advanced = username == null || !("advanced" in response2) || [
                "true",
                true
            ].includes(response2 === null || response2 === void 0 ? void 0 : response2.advanced) // 高级服务开通状态
            ;
            setAdvanced(advanced);
            dispatch((0,Common/* changeExtremeService */.xU)(advanced)) // 更新高级服务状态
            ;
            if (response2.data.contents != null) {
                result = response2.data.contents.sort((a, b)=>{
                    // 如果 a 或 b 的 lastJoined 是空数组，直接返回它们排到后面
                    if (a.lastJoined.length === 0) return 1;
                    if (b.lastJoined.length === 0) return -1;
                    // 将 lastJoined 数组转换为 Date 对象
                    const dateA = new Date(a.lastJoined[0], a.lastJoined[1] - 1, a.lastJoined[2], a.lastJoined[3], a.lastJoined[4], a.lastJoined[5]);
                    const dateB = new Date(b.lastJoined[0], b.lastJoined[1] - 1, b.lastJoined[2], b.lastJoined[3], b.lastJoined[4], b.lastJoined[5]);
                    // 返回时间差，进行倒序排序
                    return dateB - dateA;
                });
            }
            if (!advanced) result = (0,utils/* generateMockData */.W)(result) // 未升级高级服务时生成虚拟数据
            ;
        }
        if (result === null) {
            setPagination((page)=>({
                    ...page,
                    maxNum: true
                }));
            if (![
                "android-local",
                "google-cloud"
            ].includes(type)) setFetchLoading(false);
            return;
        }
        if (initWifiNetwork.length > 0) {
            setWifiNetwork((old)=>[
                    ...old,
                    ...result
                ]);
            setInitWifiNetwork((old)=>[
                    ...old,
                    ...result
                ]);
        } else {
            setWifiNetwork(result);
            setInitWifiNetwork(result);
        }
        if (![
            "android-local",
            "google-cloud"
        ].includes(type)) setFetchLoading(false);
    };
    (0,react.useEffect)(()=>{
        const nowOffset = 0;
        getWifiData(nowOffset);
    }, [
        getDeviceUser,
        type,
        userData.email
    ]);
    const dom = (0,react.useRef)(null);
    // 滚动百分比
    const [scroll, setScroll] = (0,react.useState)(0);
    // 升级成功后：预缓冲已在 notify 完成，这里重拉详情读 advanced
    (0,useExtremeUpgradeRefresh/* useExtremeUpgradeRefresh */.v)((0,react.useCallback)(()=>{
        setAdvanced(true);
        setWifiNetwork([]);
        setInitWifiNetwork([]);
        setPagination({
            reqNum: 50,
            nowOffset: 0,
            maxNum: false
        });
        setScroll(0);
        setFetchLoading(true);
        getWifiData(0);
    }, []));
    // 获取滚动百分比
    (0,react.useEffect)(()=>{
        const handScroll = ()=>{
            if (dom.current) {
                const { scrollTop , scrollHeight , clientHeight  } = dom.current;
                const progress = scrollTop / (scrollHeight - clientHeight) * 100;
                setScroll(progress.toFixed(0));
            }
        };
        const currentRef = dom.current;
        if (currentRef) {
            currentRef.addEventListener("scroll", handScroll);
        }
        return ()=>{
            if (currentRef) {
                currentRef.removeEventListener("scroll", handScroll);
            }
        };
    }, []);
    // 监听滚动百分比
    (0,react.useEffect)(()=>{
        if (scroll >= 100 && advanced) {
            const nowOffset = pagination.nowOffset + pagination.reqNum;
            setPagination((page)=>({
                    ...page,
                    nowOffset
                }));
        // if (!pagination.maxNum) getWifiData(nowOffset)
        }
    }, [
        scroll
    ]);
    // 处理弹出
    let getWifiInfo = (info)=>{
        if (advanced) {
            setWifiInfo(info);
            childRef.current.toggleDrawerParent("right", true);
        }
    };
    // 处理搜索
    const handleFilter = (e)=>{
        let value = e.target.value;
        if (value === "") {
            setWifiNetwork(initWifiNetwork);
            return;
        }
        // 搜索过滤
        let filterData = initWifiNetwork.filter((item)=>{
            if (item.SSID_STR) {
                return item.SSID_STR.toLowerCase().indexOf(value.toLowerCase()) !== -1;
            } else if (item.name) {
                return item.name.toLowerCase().indexOf(value.toLowerCase()) !== -1;
            }
        });
        setWifiNetwork(filterData);
    };
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        const title = t("Wi-Fi network");
        dispatch((0,Common/* setCurrentTab */.Lw)(title));
        return ()=>dispatch((0,Common/* setCurrentTab */.Lw)(""));
    }, [
        dispatch,
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "format-detection",
                    content: "telephone=no"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-[#FFF] [box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] Bxl:h-[calc(var(--vh2)*100-94px)] Bxls:Headers5:h-[calc(var(--vh2)*100-149px)] Header5:big:h-[calc(var(--vh2)*100-214px)] bigs:h-[calc(var(--vh2)*100-274px)] pb-[20px] flex flex-col relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full px-[15px] pt-[15px] pb-[3px] ".concat(!advanced ? "blur-[16px] select-none" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                            fullWidth: true,
                            className: "h-[40px] bg-[rgba(235,235,239,0.92)] rounded-lg !border-0 text-[16px]",
                            size: "small",
                            onInput: (e)=>{
                                advanced && handleFilter(e);
                            },
                            placeholder: t("Search Wi-Fi"),
                            sx: {
                                "& .MuiInputBase-root .MuiOutlinedInput-notchedOutline": {
                                    border: 0
                                },
                                "& input::placeholder": {
                                    fontSize: "16px",
                                    color: "#818187",
                                    opacity: 100
                                }
                            },
                            InputProps: {
                                startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                    position: "start",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/images/contacts/search.svg",
                                        width: 18,
                                        height: 18,
                                        alt: "search"
                                    })
                                })
                            }
                        })
                    }),
                    !fetchLoading && !gatePending && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: !basicNotOver && !advancedNotOver && !justVerified ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: showUpgradeModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(extreme_upgrade/* default */.ZP, {
                                open: true
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollDiv, {
                        ref: dom,
                        className: "w-full h-full relative z-10 ".concat(advanced ? "overflow-auto" : "overflow-hidden blur-[16px] select-none"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                className: "border-separate border-spacing-x-[15px] border-spacing-y-[10px] w-full smj:hidden",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        className: "sticky top-0 bg-[#FFF]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                className: "pt-[8px] text-start Blds:text-center text-[14px] text-[#000] font-[600] text-nowrap",
                                                children: t("WIFI NAME")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                                                className: "pt-[8px] text-end Blds:text-center text-[14px] text-[#000] font-[600] text-nowrap",
                                                children: [
                                                    !(type === "google-cloud") && t("LAST JOINED"),
                                                    type === "google-cloud" && t("PASSWORD")
                                                ]
                                            }),
                                            type === "android-local" && /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                className: "pt-[8px] text-end Blds:text-center text-[14px] text-[#000] font-[600] text-nowrap",
                                                children: t("LOCATION")
                                            })
                                        ]
                                    }),
                                    wifiNetwork.map((row, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            onClick: ()=>{
                                                getWifiInfo(row);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "text-[14px] text-[#000] text-nowrap text-start Blds:text-center",
                                                    children: row.SSID_STR || row.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                    className: "text-[14px] text-[#000] text-nowrap text-end Blds:text-center",
                                                    children: [
                                                        !type === "google-cloud" && row.time,
                                                        type === "google-cloud" && row.password
                                                    ]
                                                }),
                                                type === "android-local" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                    className: "text-[14px] text-[#000] text-nowrap text-end Blds:text-center",
                                                    children: [
                                                        row.lat,
                                                        row.lon
                                                    ]
                                                })
                                            ]
                                        }, i))
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "smjs:hidden h-auto",
                                children: wifiNetwork.map((row, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(!advanced ? "blur-[16px] select-none" : "", " flex w-full px-[15px]"),
                                        onClick: ()=>{
                                            getWifiInfo(row);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "border-[#e6e6e6] border-b-[0.5px] w-full flex flex-col justify-center py-[12px] font-[Poppins]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex justify-between items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "max-w-[50%] break-all text-[16px] font-[400] leading-[24px]",
                                                        children: row.SSID_STR || row.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "text-[14px] font-[400] leading-[21px]",
                                                        children: [
                                                            !type === "google-cloud" && row.time || row.lastJoined && row.lastJoined.length > 0 && dayjs_min_default()("".concat(row.lastJoined[0], "/").concat(row.lastJoined[1], "/").concat(row.lastJoined[2], " ").concat(row.lastJoined[3], ":").concat(row.lastJoined[4])).format("YYYY/MM/DD HH:mm"),
                                                            type === "google-cloud" && row.password
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }, index))
                            })
                        ]
                    }),
                    advanced && initWifiNetwork.length == 0 && !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-center px-2 absolute inset-0 flex justify-center items-center pointer-events-none",
                        children: [
                            t("It appears theres no data to show here yet"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            t("If data exists it may take up to 1 hour to download and appear"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            t("We suggest checking back in a little while")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(wifi_info, {
                data: wifiInfo,
                ref: childRef
            })
        ]
    });
};
/* harmony default export */ var components_WifiNetworks = (WifiNetworks);


/***/ }),

/***/ 9644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useExtremeFeatureAccessGate; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var src_utils_iosIcloudBindStatus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66017);




/**
 * Extreme 功能页门控（仅 iOS-Cloud 有基础/高级绑定）
 *
 * - 未绑定高级：跳转 /ios/extreme-verification
 * - 已绑未购：出升级弹窗
 * - resetTime 未就绪：gatePending
 */ function useExtremeFeatureAccessGate(hasExtremePlan) {
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const resetTime = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)((state)=>state.Common.resetTime);
    const currentMode = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)((state)=>state.Common.currentMode);
    const deviceSwitchRevision = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)((state)=>state.Common.deviceSwitchRevision);
    const isIos = (0,src_utils_iosIcloudBindStatus__WEBPACK_IMPORTED_MODULE_3__/* .shouldApplyIosExtremeBindGate */ .yI)(currentMode);
    const resetTimePending = isIos && (0,src_utils_iosIcloudBindStatus__WEBPACK_IMPORTED_MODULE_3__/* .isResetTimePending */ .z6)(resetTime);
    const advancedNotBound = isIos && (0,src_utils_iosIcloudBindStatus__WEBPACK_IMPORTED_MODULE_3__/* .isAdvancedVerificationIncomplete */ .dU)(resetTime);
    const extremePlan = hasExtremePlan === true || hasExtremePlan === "true";
    const gatePending = resetTimePending;
    const needsExtremeBindPage = isIos && !gatePending && advancedNotBound;
    const showUpgradeModal = isIos && !gatePending && !advancedNotBound && !extremePlan;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!needsExtremeBindPage) return;
        if (router.pathname === "/ios/extreme-verification") return;
        router.replace("/ios/extreme-verification");
    }, [
        needsExtremeBindPage,
        router,
        deviceSwitchRevision
    ]);
    return {
        resetTimePending,
        gatePending,
        advancedNotOver: advancedNotBound,
        needsExtremeBindPage,
        showUpgradeModal
    };
}


/***/ }),

/***/ 57921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useExtremeUpgradeRefresh; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_constants_extremeUpgrade__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76919);


/**
 * 订阅 Extreme 升级成功事件，刷新「当前所在功能页」的数据与 advanced 状态。
 *
 * 使用场景：页面内嵌了 ExtremeModal，用户在不离开页面的情况下完成升级后，
 * 需要去掉模糊遮罩并重新请求本页接口（如 smsChat-summary / getAllDashboard 等）。
 *
 * 刷新顺序（与 spyx / 后端缓存策略对齐）：
 * 1. notifyExtremeUpgraded 内已 await USER_SUMMARY 预缓冲（触发后台 advanced 同步）
 * 2. 本 hook 再 await primeExtremeAdvancedCache（二次预热，读到同步后的 advanced）
 * 3. 再执行 onUpgraded → 本页业务详情接口，用返回的 advanced 解锁 UI
 *
 * 注意：
 * - onUpgraded 内应复用「设备切换」时的重置 + 拉数逻辑（与 useDeviceScopedInit 保持一致）
 * - 建议先 setAdvanced(true) 乐观解锁 UI，再 dispatch 拉真实数据
 * - onUpgraded 可为 async；须 useCallback 包裹，避免重复注册监听
 *
 * @param {() => void | Promise<void>} onUpgraded - 升级成功后的刷新回调
 *
 * @example
 * useExtremeUpgradeRefresh(
 *   useCallback(() => {
 *     setAdvanced(true)
 *     dispatch(fetchUserProfile()) // hook 内已先 USER_SUMMARY，再执行此处
 *   }, [dispatch])
 * )
 */ function useExtremeUpgradeRefresh(onUpgraded) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!onUpgraded) return;
        const handler = async ()=>{
            await (0,src_constants_extremeUpgrade__WEBPACK_IMPORTED_MODULE_1__/* .primeExtremeAdvancedCache */ .ti)();
            await Promise.resolve(onUpgraded());
        };
        window.addEventListener(src_constants_extremeUpgrade__WEBPACK_IMPORTED_MODULE_1__/* .EXTREME_UPGRADED_EVENT */ .zp, handler);
        return ()=>window.removeEventListener(src_constants_extremeUpgrade__WEBPACK_IMPORTED_MODULE_1__/* .EXTREME_UPGRADED_EVENT */ .zp, handler);
    }, [
        onUpgraded
    ]);
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useExtremeUpgradeRefresh)));


/***/ }),

/***/ 67135:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contactsInfo":"wifi-info_contactsInfo__tfh8n","arrow":"wifi-info_arrow__yIn9F","top":"wifi-info_top__28ju4","pic":"wifi-info_pic__ok8nW","name":"wifi-info_name__BxScL","contentBox":"wifi-info_contentBox__dyyG9","containers":"wifi-info_containers__dl5wm","icon":"wifi-info_icon__WUlrt","text":"wifi-info_text__89Z9_","number":"wifi-info_number__ZUdUq"};

/***/ })

}]);